/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AdministrationByScheduleAliases {
  ADMINISTRATION_BY_SCHEDULE_ACCORDION = 'administration-by-schedule-accordion',
  ADMINISTRATION_BY_SCHEDULE_ACCORDION_PANEL = 'administration-by-schedule-accordion-panel',
  ADMINISTRATION_BY_SCHEDULE_ACCORDION_PLUS_TITLE_PANEL = 'administration-by-schedule-accordion-plus-title-panel',
  ADMINISTRATION_BY_SCHEDULE_ACCORDION_PLUS_TITLE_TEXT = 'administration-by-schedule-accordion-plus-title-text',
  ADMINISTRATION_BY_SCHEDULE_ACCORDION_TITLE_PANEL = 'administration-by-schedule-accordion-title-panel',
  ADMINISTRATION_BY_SCHEDULE_ACCORDION_TITLE_TEXT = 'administration-by-schedule-accordion-title-text',
  ADMINISTRATION_BY_SCHEDULE_ADMIN_ROUTE_FIELD = 'administration-by-schedule-admin-route-field',
  ADMINISTRATION_BY_SCHEDULE_ADMIN_ROUTE_INPUT = 'administration-by-schedule-admin-route-input',
  ADMINISTRATION_BY_SCHEDULE_BARCODE = 'administration-by-schedule-barcode',
  ADMINISTRATION_BY_SCHEDULE_BARCODE_PANEL = 'administration-by-schedule-barcode-panel',
  ADMINISTRATION_BY_SCHEDULE_BUTTON = 'administration-by-schedule-button',
  ADMINISTRATION_BY_SCHEDULE_BUTTON_PANEL_PADDING = 'administration-by-schedule-button-panel-padding',
  ADMINISTRATION_BY_SCHEDULE_CARD = 'administration-by-schedule-card',
  ADMINISTRATION_BY_SCHEDULE_CARD_DECK = 'administration-by-schedule-card-deck',
  ADMINISTRATION_BY_SCHEDULE_CARD_PANEL = 'administration-by-schedule-card-panel',
  ADMINISTRATION_BY_SCHEDULE_CARDS_ACCORDION = 'administration-by-schedule-cards-accordion',
  ADMINISTRATION_BY_SCHEDULE_CARDS_ACCORDION_PANEL = 'administration-by-schedule-cards-accordion-panel',
  ADMINISTRATION_BY_SCHEDULE_CONTENT_PANEL = 'administration-by-schedule-content-panel',
  ADMINISTRATION_BY_SCHEDULE_DATE_TIME_FIELD = 'administration-by-schedule-date-time-field',
  ADMINISTRATION_BY_SCHEDULE_DATE_TIME_TEXT = 'administration-by-schedule-date-time-text',
  ADMINISTRATION_BY_SCHEDULE_DILUTION_FIELD = 'administration-by-schedule-dilution-field',
  ADMINISTRATION_BY_SCHEDULE_DILUTION_TEXT_AREA = 'administration-by-schedule-dilution-text-area',
  ADMINISTRATION_BY_SCHEDULE_FORM = 'administration-by-schedule-form',
  ADMINISTRATION_BY_SCHEDULE_JUSTIFICATION_FIELD = 'administration-by-schedule-justification-field',
  ADMINISTRATION_BY_SCHEDULE_JUSTIFICATION_TEXT_AREA = 'administration-by-schedule-justification-text-area',
  ADMINISTRATION_BY_SCHEDULE_LAYOUT = 'administration-by-schedule-layout',
  ADMINISTRATION_BY_SCHEDULE_NAME_DATE_PANEL = 'administration-by-schedule-name-date-panel',
  ADMINISTRATION_BY_SCHEDULE_NAME_FIELD = 'administration-by-schedule-name-field',
  ADMINISTRATION_BY_SCHEDULE_NAME_TEXT = 'administration-by-schedule-name-text',
  ADMINISTRATION_BY_SCHEDULE_NEW_DATE_FIELD = 'administration-by-schedule-new-date-field',
  ADMINISTRATION_BY_SCHEDULE_NEW_DATE_INPUT = 'administration-by-schedule-new-date-input',
  ADMINISTRATION_BY_SCHEDULE_OBSERVATION_FIELD = 'administration-by-schedule-observation-field',
  ADMINISTRATION_BY_SCHEDULE_OBSERVATION_TEXT_AREA = 'administration-by-schedule-observation-text-area',
  ADMINISTRATION_BY_SCHEDULE_QUANTITY_FIELD = 'administration-by-schedule-quantity-field',
  ADMINISTRATION_BY_SCHEDULE_QUANTITY_INPUT = 'administration-by-schedule-quantity-input',
  ADMINISTRATION_BY_SCHEDULE_UNITY_FIELD = 'administration-by-schedule-unity-field',
  ADMINISTRATION_BY_SCHEDULE_UNITY_INPUT = 'administration-by-schedule-unity-input',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LEGENDS_ADMINISTRAITION_BY_SCHEDULE = 'legends-administraition-by-schedule',
}
export { AdministrationByScheduleAliases };
